module.exports = __webpack_public_path__ + "static/media/latvia.436958ec.png";